"use client";

import { useMemo, useState } from "react";

import VehicleCard from "@/app/(pages)/(frontend)/t/[tenant]/gebrauchtwagen/components/vehicle-card";
import { Button } from "@/app/components/ui/button";
import type { VehicleRow } from "@/app/(pages)/(frontend)/t/[tenant]/gebrauchtwagen/lib/fetch-vehicle-data";

type ElectricVehicleListClientPropsT = {
  vehicles: VehicleRow[];
  initialLimit: number;
  increment?: number;
};

export default function ElectricVehicleListClient({
  vehicles,
  initialLimit,
  increment,
}: ElectricVehicleListClientPropsT) {
  const loadIncrement = increment ?? initialLimit;
  const [visibleCount, setVisibleCount] = useState(initialLimit);

  const visibleVehicles = useMemo(
    () => vehicles.slice(0, visibleCount),
    [vehicles, visibleCount]
  );

  const hasMore = visibleCount < vehicles.length;

  return (
    <div className="mt-8 space-y-6">
      {visibleVehicles.map((vehicle) => (
        <VehicleCard key={vehicle.vehicleid} vehicle={vehicle} />
      ))}
      {hasMore ? (
        <div className="pt-4 text-center">
          <Button
            variant="secondary"
            onClick={() =>
              setVisibleCount((prev) =>
                Math.min(prev + loadIncrement, vehicles.length)
              )
            }
          >
            Weitere Fahrzeuge laden
          </Button>
        </div>
      ) : null}
    </div>
  );
}
